import { useMemo } from "react";
import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import clsx from "clsx";
import { useDatePickerContext } from "../AvailabilityPage/context/DatePickerContext";
import defaultStyles from "./HotelListNoHotels.module.scss";
import { ActionButton } from "@/components/ActionButton";

export const HotelListNoHotels = ({
  className,
  children,
}: PlatformComponentProps) => {
  const COMPONENT_KEY = CoreHotelsComponent.HotelListNoHotels;
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const hasFilterApplied = false;

  const { t } = useI18nContext();
  const { openDatePicker } = useDatePickerContext();

  const subtitle = useMemo(() => {
    return hasFilterApplied
      ? t(
          "core-hotels.availabilityPage.results.noResults.filteredHotelsNotFound"
        )
      : t("core-hotels.availabilityPage.results.noResults.noHotelsAvailable");
  }, [hasFilterApplied, t]);

  const title = t(
    "core-hotels.availabilityPage.results.noResults.noHotelsFound"
  );

  return (
    <div className={clsx(block, className)}>
      <div className={cn("title")}>{title}</div>
      <div className={cn("subtitle")}>{subtitle}</div>
      <ActionButton
        message={t(
          "core-hotels.availabilityPage.results.noResults.changeDates"
        )}
        onClick={openDatePicker}
      />
      {children}
    </div>
  );
};
